import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IEdgeFlags } from '../../ts/Interfaces';
import { OrientationType } from './Interfaces';

export interface IResize {
    orient: OrientationType;
    dx: number;
    dy: number;
}

function processResize(style, resize: IResize) {
    switch (resize.orient) {
        case 'top':
            style.top += resize.dy;
            style.height -= resize.dy;
            break;

        case 'right':
            style.width += resize.dx;
            break;

        case 'bottom':
            style.height += resize.dy;
            break;

        case 'left':
            style.left += resize.dx;
            style.width -= resize.dx;
            break;
    }

    return style;
}

export default class LayoutContainerBlock extends React.Component<
    {
        dragScope?: string;

        cell?: {
            width: number;
            height: number;
        };

        orderIndex?: number;
        hidden?: boolean;
        dragAllowed?: boolean;
        style: React.CSSProperties;
        resize?: IResize;
        stack?: boolean;
        enableResize?: boolean;
        edgeFlags?: IEdgeFlags;

        onSpecialAction?(e): void;
        onResizeStart?(e, orderIndex: number, orientation: OrientationType): void;

        children?: React.ReactNode;
    },
    {}
> {
    private container: HTMLDivElement;
    private dragHelper: HTMLDivElement;

    constructor(props) {
        super(props);
    }

    handleDragStart = (e, ui) => {
        $(this.container).addClass('dragging');
    };

    handleDragStop = (e, ui) => {
        $(this.container).removeClass('dragging');
    };

    getDragHelper = () => {
        const clone = $(this.dragHelper).clone();

        clone.removeAttr('data-reactid');

        clone.find('*').each(function () {
            $(this).removeAttr('data-reactid');
        });

        return clone;
    };

    componentDidMount() {
        const container = $(this.container);

        if (this.props.cell != null) {
            container
                .draggable({
                    helper: this.getDragHelper,
                    appendTo: container.parent(),
                    handle: '.canvas-overlay-' + this.props.dragScope,

                    start: this.handleDragStart,
                    stop: this.handleDragStop,

                    cursorAt: {
                        left: this.props.cell.width / 2,
                        top: this.props.cell.height / 2
                    },

                    scope: this.props.dragScope
                })
                .data('payload', {
                    type: 'widget',
                    orderIndex: this.props.orderIndex,
                    remainSize: true
                });
        }

        container.on('dblclick', this.handleDblClick);
    }

    componentWillUnmount() {
        const container = $(this.container);

        container.off('dblclick', this.handleDblClick);

        if (this.props.cell != null) {
            container.draggable('destroy');
        }
    }

    componentDidUpdate(prevProps, prevState) {
        let triggerResize =
            this.props.style != null &&
            prevProps.style != null &&
            (prevProps.style.width !== this.props.style.width || prevProps.style.height !== this.props.style.height);

        triggerResize = triggerResize || prevProps.dragAllowed !== this.props.dragAllowed;
        triggerResize = triggerResize || (this.props.hidden === false && prevProps.hidden !== this.props.hidden);
        triggerResize = triggerResize && !this.props.hidden;

        if (triggerResize && this.props.enableResize) {
            // This path should be kept updated,
            // when inner DOM structure is changed after further
            // code modifications
            $(this.container)
                .find(
                    '> .widget > .widget-inner-container' +
                        '> .widget-canvas > .layout-container' +
                        '> .inner-layout-container > .layout-container-block' +
                        '> .widget-canvas-main, ' +
                        '> .widget-canvas-main'
                )
                .trigger('resize');
        }
    }

    handleDblClick = (e) => {
        if (!this.props.dragAllowed) {
            return;
        }

        if (typeof this.props.onSpecialAction === 'function') {
            this.props.onSpecialAction(e);
        }
    };

    getDragStartHandler = (orientation: OrientationType) => {
        return (e) => {
            if (typeof this.props.onResizeStart === 'function') {
                this.props.onResizeStart(e, this.props.orderIndex, orientation);
            }
        };
    };

    render() {
        const resizeControls = [
            <div
                key="resize-control-top"
                className="resize-control top"
                onMouseDown={this.getDragStartHandler('top')}
                onTouchStart={this.getDragStartHandler('top')}
            ></div>,
            <div
                key="resize-control-right"
                className="resize-control right"
                onMouseDown={this.getDragStartHandler('right')}
                onTouchStart={this.getDragStartHandler('right')}
            ></div>,
            <div
                key="resize-control-bottom"
                className="resize-control bottom"
                onMouseDown={this.getDragStartHandler('bottom')}
                onTouchStart={this.getDragStartHandler('bottom')}
            ></div>,
            <div
                key="resize-control-left"
                className="resize-control left"
                onMouseDown={this.getDragStartHandler('left')}
                onTouchStart={this.getDragStartHandler('left')}
            ></div>
        ];

        let style = _.clone(this.props.style);

        if (this.props.resize != null && style != null) {
            style = processResize(style, this.props.resize);
        }

        const styleRender = _.clone(style);

        if (styleRender != null) {
            delete styleRender.right;
            delete styleRender.bottom;
        }

        const edgeFlags = this.props.edgeFlags ?? {};
        //<-IL: 78900: "Edit WS" mode. It's impossible to delete a widget which has a long header title, so the [X] button is in the 2nd row = BUG
        const widgetControlPanel = $(this.container).find('.widget-control-panel');
        const canvasStyle: React.CSSProperties = {};

        if (widgetControlPanel.length > 0) {
            const top = widgetControlPanel[0].clientHeight;

            if (top != null) {
                canvasStyle.top = top + 'px';
            }
        }

        if (edgeFlags.top) {
            canvasStyle.marginTop = 0;
        }

        if (edgeFlags.right) {
            canvasStyle.marginRight = 0;
        }

        if (edgeFlags.bottom) {
            canvasStyle.marginBottom = 0;
        }

        if (edgeFlags.left) {
            canvasStyle.marginLeft = 0;
        }

        return (
            <div
                ref={(input) => {
                    this.container = input;
                }}
                key={this.props.orderIndex}
                className={
                    'layout-container-block' +
                    (this.props.stack ? ' stack' : '') +
                    (this.props.hidden ? ' hidden-block' : '') +
                    (edgeFlags.top !== false ? ' edge-top' : '') +
                    (edgeFlags.right !== false ? ' edge-right' : '') +
                    (edgeFlags.bottom !== false ? ' edge-bottom' : '') +
                    (edgeFlags.left !== false ? ' edge-left' : '')
                }
                style={styleRender}
            >
                {this.props.children}

                {resizeControls}

                <div className={'canvas-overlay' + ' canvas-overlay-' + this.props.dragScope} style={canvasStyle}></div>

                <div
                    ref={(input) => {
                        this.dragHelper = input;
                    }}
                    className="layout-container-block layout-container-block-drag-helper"
                    style={styleRender}
                ></div>
            </div>
        );
    }
}
